<template>
  <div class="c-submitButton">
    <input
      type="submit"
      class="member-form__submit o-button o-button--green"
      :class="submitting ? 'disabled' : ''"
      :value="value"
      name="member_submit"
      id="submit_id"
      @click="validateForm"
    />
    <div
      type="submit"
      class="member-form__submit o-button o-button--green o-button--disabled"
      :value="value"
      name="member_submit"
      id="submit_id"
      v-if="submitting"
    >
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubmitButton",
  components: {},
  props: {
    value: String,
  },
  data: () => {
    return {
      submitting: false,
    };
  },
  computed: {},
  methods: {
    validateForm() {
      const form = document.getElementById("member-form__form");
      if (
        !form.name.value ||
        !form.address.value ||
        !form.zip.value ||
        !form.city.value ||
        !form.birthdate.value ||
        !form.email.value ||
        !form.phone.value ||
        !form.terms.checked
      ) {
        return;
      }
      this.submitting = true;
    },
  },
};
</script>

<style lang="scss">
.c-submitButton {
  .disabled {
    display: none;
  }
  .o-button--disabled {
    opacity: 0.6 !important;
  }

  .lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-ellipsis div {
    position: absolute;
    top: 12px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  .lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  .lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(24px, 0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// assets/_js/components/vue/objects/SubmitButton.vue